/**
 * Client-side RBAC helpers — mirrors backend/app/rbac.py rules.
 */

export const ROLE_LEVELS: Record<string, number> = {
  viewer: 1,
  analyst: 2,
  tenant_admin: 3,
  super_admin: 4,
};

export function hasMinRole(userRole: string, minRole: string): boolean {
  return (ROLE_LEVELS[userRole] ?? 0) >= (ROLE_LEVELS[minRole] ?? 0);
}

export function canAssignRole(
  adminRole: string,
  adminOrgLevel: string | null,
  targetRole: string,
): boolean {
  const adminLevel = ROLE_LEVELS[adminRole] ?? 0;
  const targetLevel = ROLE_LEVELS[targetRole] ?? 0;

  if (targetLevel >= adminLevel) return false;

  if (!adminOrgLevel || adminOrgLevel === 'federal') return true;

  if (adminOrgLevel === 'canton') {
    return ['tenant_admin', 'analyst', 'viewer'].includes(targetRole);
  }

  if (adminOrgLevel === 'commune') {
    return ['analyst', 'viewer'].includes(targetRole);
  }

  return false;
}

export function getAssignableRoles(
  adminRole: string,
  adminOrgLevel: string | null,
): string[] {
  return ['viewer', 'analyst', 'tenant_admin'].filter((role) =>
    canAssignRole(adminRole, adminOrgLevel, role),
  );
}

export function canCreateChildOrg(adminOrgLevel: string | null, childLevel: string): boolean {
  if (!adminOrgLevel || adminOrgLevel === 'federal') return true;
  if (adminOrgLevel === 'canton') return childLevel === 'commune';
  return false;
}

export function canAssignRoleToOrg(
  adminOrgLevel: string | null,
  targetOrgLevel: string,
  targetRole: string,
): boolean {
  if (!adminOrgLevel || adminOrgLevel === 'federal') return true;
  if (adminOrgLevel === 'canton' && targetRole === 'tenant_admin') {
    return targetOrgLevel === 'commune';
  }
  return true;
}

export function canInviteUsers(role: string): boolean {
  return hasMinRole(role, 'tenant_admin');
}
